import { GetListParams } from 'react-admin';
import { CustomDataProvider } from '../../providers/CustomDataProvider';
import { baseUrl, httpClient } from '../../providers/AppDataProvider';

export class DataProvider implements CustomDataProvider {
  // eslint-disable-next-line class-methods-use-this
  async getList(resource: string, params: GetListParams): Promise<any> {
    if (resource !== 'invite-codes')
      return Promise.reject(new Error('Unsupported getList resource'));

    const { page = 1, perPage = 10 } = params.pagination || {};
    const { filter = {}, meta = {} } = params;

    // 构建请求 URL
    const url = `${baseUrl}/invite-codes`;

    try {
      const { json } = await httpClient(url);
      let rows: any[] = [];
      let total = 0;
      rows = json;

      // 客户端筛选：支持 id、categoryId、startDate、endDate
      const { userId: idFilter, code: codeFilter } = (filter ?? {}) as any;
      if (idFilter != null || codeFilter != null) {
        rows = rows.filter((row: any) => {
          if (idFilter != null && `${row?.userId}` === `${idFilter}`) return true;
          return codeFilter != null && `${row?.code}` === `${codeFilter}`;
        });
      }

      total = rows.length;

      // 确保每条记录都有 id，并限制处理的数据量
      const allData = rows
        .slice(0, 10000)
        .map((r: any, i: number) => (r?.id != null ? r : { id: `${i}`, ...r }));

      // 前端分页处理
      const startIndex = (page - 1) * perPage;
      const endIndex = startIndex + perPage;
      const data = allData.slice(startIndex, endIndex);

      return { data, total: Math.min(total, 10000) };
    } catch (error) {
      console.error('inviteCodes getList error:', error);
      throw error;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async create(resource: string, params: any): Promise<any> {
    if (resource !== 'invite-codes')
      return Promise.reject(new Error('Unsupported create resource'));

    const url = `${baseUrl}/invite-codes`;
    const payload = params?.data ?? {};

    try {
      const { json } = await httpClient(url, {
        method: 'POST',
        body: JSON.stringify(payload),
      });

      // API 返回数组格式: [{ "code": "JSF659", "userId": null, "verified": false }]
      // 需要转换为框架需要的格式，确保有 id 字段
      let result;
      if (Array.isArray(json) && json.length > 0) {
        result = json[0];
      } else if (json && typeof json === 'object') {
        result = json;
      } else {
        result = payload;
      }
      // 确保返回的数据有 id 字段（使用 code 作为 id）
      return { data: { ...result, id: result.code || payload.code } };
    } catch (error) {
      console.error('inviteCodes create error:', error);
      throw error;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async update(resource: string, params: any): Promise<any> {
    if (resource !== 'invite-codes')
      return Promise.reject(new Error('Unsupported update resource'));

    // code 可能来自 params.code 或 params.id
    const code = params.code || params.id;
    const url = `${baseUrl}/invite-codes/${code}`;
    const payload = params?.data ?? {};

    try {
      const { json } = await httpClient(url, {
        method: 'PUT',
        body: JSON.stringify(payload),
      });

      // API 返回对象格式: { "code": "JSF659", "userId": "zhangwei", "verified": false }
      // 需要确保有 id 字段（使用 code 作为 id）
      const result = json ?? payload;
      return { data: { ...result, id: code } };
    } catch (error) {
      console.error('inviteCodes update error:', error);
      throw error;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async delete(resource: string, params: any): Promise<any> {
    return;
  }
}

// 创建实例并导出
export const dataProvider = new DataProvider();
